import { isMobileVersion, popupWindowToCenter } from 'utils/general';
import SectionItem from './SectionItem';

interface SocialMediaSectionProps {
  linkUrl: string;
}

function SocialMedia({ linkUrl }: SocialMediaSectionProps) {
  const handleShareWhatsapp = () => {
    let linkShare;
    if (isMobileVersion()) {
      linkShare = `whatsapp://send?text=${linkUrl}`;
      popupWindowToCenter(linkShare, '', 350, 350);
    } else {
      linkShare = `https://api.whatsapp.com/send?text=${encodeURIComponent(
        linkUrl,
      )}`;
      window.open(linkShare, '_blank');
    }
  };

  const handleShareTelegram = () => {
    const linkShare = `https://telegram.me/share/url?url=${encodeURIComponent(
      linkUrl,
    )}`;

    if (isMobileVersion()) {
      popupWindowToCenter(linkShare, '', 350, 350);
    } else {
      window.open(linkShare, '_blank');
    }
  };

  const handleShareTwitter = () => {
    const linkShare = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      linkUrl,
    )}`;

    window.open(linkShare, '_blank');
  };

  return (
    <>
      <SectionItem
        background="#25d366"
        onClick={handleShareWhatsapp}
        src="/images/whatsapp-logo.svg"
        caption="Whats App"
        imageStyle={{
          padding: '13px',
        }}
      />
      <SectionItem
        background="#08c"
        onClick={handleShareTelegram}
        src="/images/telegram-logo.svg"
        caption="Telegram"
        imageStyle={{
          padding: '13px',
        }}
      />
      <SectionItem
        background="#1b9df0"
        onClick={handleShareTwitter}
        src="/images/twitter-logo.svg"
        caption="Twitter"
        imageStyle={{
          padding: '0px',
        }}
      />
    </>
  );
}

export default SocialMedia;
